
import { mapState } from 'vuex';
import { Flicking } from '@egjs/vue-flicking';
import ReviewShortsMedium from './components/ReviewShortsMedium';
import { SWIPE_THRESHOLD } from '@/constants/SHORTS_POPUP';
import CoachMark from './components/CoachMark';

const FLICKING_OPTIONS = {
  bound: true,
  horizontal: false,
  panelsPerView: 1,
  moveType: 'strict',
  threshold: SWIPE_THRESHOLD
};

export default {
  i18nComponentKey: 'ReviewsShortsPopup.ReviewsShortsPopupMobile',
  name: 'ReviewsShortsPopupMobile',
  components: {
    Flicking,
    ReviewShortsMedium,
    CoachMark
  },
  props: {
    reviewMedia: {
      type: Array,
      required: true
    },
    pagy: {
      type: Object,
      default: null
    },
    popupParams: {
      type: Object,
      default: () => ({})
    },
    isVideoMuted: {
      type: Boolean,
      default: true
    },
    showCoachMark: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    initialMediaIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: null,
      isPinchZooming: false
    };
  },
  computed: {
    ...mapState('bottomSheet', ['bottomSheet']),
    flickingOptions() {
      return {
        ...FLICKING_OPTIONS,
        defaultIndex: this.initialMediaIndex
      };
    },
    showHeader() {
      return (
        !this.isPinchZooming &&
        !(this.bottomSheet?.component?.name === 'ReviewDetailDialog')
      );
    }
  },
  methods: {
    onMoveEnd(event) {
      if (this.currentIndex === null) return;

      const shouldMoveNext =
        this.currentIndex === this.reviewMedia.length - 1 &&
        event.direction === 'PREV' &&
        this.pagy.next;
      const shouldMovePrev =
        this.currentIndex === 0 && event.direction === 'NEXT' && this.pagy.prev;

      if (shouldMovePrev) {
        this.$emit('prepend-page', {
          page: this.pagy.prev,
          callback: addedCount => {
            this.$refs.flicking.moveTo(addedCount, 0);
            this.currentIndex = addedCount;
          }
        });
      } else if (shouldMoveNext) {
        this.$emit('append-page', { page: this.pagy.next });
      }
    },
    onWillChange(e) {
      this.currentIndex = e.index;
    },
    onFlickingReady() {
      if (!this.$refs.flicking) return;

      this.currentIndex = this.$refs.flicking.index;
    },
    onPinchZoomChange(isPinchZooming) {
      this.isPinchZooming = isPinchZooming;
      const flicking = this.$refs.flicking;
      if (!flicking) return;

      if (isPinchZooming) {
        flicking.disableInput();
      } else {
        flicking.enableInput();
      }
    }
  }
};
